<!-- Breadcrumb End -->
<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>Mock Test</h1>
            <ul>
                <li>
                    <a [routerLink]="['/dashboard']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i>
                        Back</a>
                </li>
            </ul>
        </div>
    </div>
</div>
<!-- Breadcrumb Start -->

<!-- plan Section Start -->
<app-plans></app-plans>

<app-buy-book></app-buy-book>
